import { MutableRefObject } from "react";

export const sideNavigate = (
	navElement: MutableRefObject<HTMLElement | null>,
	direction: string,
	speed: number,
	distance: number,
	step: number,
	onSideNavigateFinished?: (direction: string, reachedRightEnd: boolean) => void,
) => {
	const { current } = navElement;
	if (current) {
		let scrollAmount = 0;
		// Used to scroll nav horisontally with some interval to create some animation
		const slideTimer = setInterval(() => {
			if (direction === "left") {
				current.scrollLeft -= step;
			} else {
				current.scrollLeft += step;
			}
			scrollAmount += step;

			if (scrollAmount >= distance) {
				const hasReachedRightEnd = (): boolean => {
					const currentReach = current.scrollWidth - current.clientWidth;
					/**
					 * Round the current.scrollLeft to the nearest whole integer,
					 * this covers systems using scaling where scrollLeft may give you a decimal value.
					 * (Scaling = zoom in browser or scaling applied to screen).
					 */
					const roundedScrollLeft = Math.round(current.scrollLeft);
					switch (true) {
						/**
						 * Allow exact match and also an error margin of < 2px
						 * to be considered "reached the end"
						 */
						case currentReach === roundedScrollLeft:
						case currentReach === roundedScrollLeft - 2:
						case currentReach === roundedScrollLeft - 1:
							return true;
						default:
							return false;
					}
				};

				window.clearInterval(slideTimer);
				if (onSideNavigateFinished) onSideNavigateFinished(direction, hasReachedRightEnd());
			}
		}, speed);
	}
};
